<template lang="pug">
    <div>
      span {{ item.address }}
      </div>

</template>

<script>
    export default {
        props: {
            item: { required: true }
        }
    }
</script>